module.exports = __webpack_public_path__ + "img/craft_1.6510425b.jpg";